import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Check } from "lucide-react";
import { PACKAGES, COURSES, inr } from "@/data/content";
import { Reveal, CourseCard, useBuyPackage } from "@/components/site/ui";
import { NotFound } from "./CourseDetail";

export default function PackageDetail() {
  const { slug } = useParams();
  const buy = useBuyPackage();
  const p = PACKAGES.find((x) => x.slug === slug);
  if (!p) return <NotFound to="/packages" label="Back to packages" />;
  const included = COURSES.filter((c) => p.courses.includes(c.slug));
  const save = Math.round((1 - p.price / p.oldPrice) * 100);

  return (
    <div data-testid="package-detail-page" className="max-w-7xl mx-auto px-5 sm:px-8 pt-10">
      <Link to="/packages" className="inline-flex items-center gap-2 text-sm text-[var(--muted)] hover:text-[var(--pink)]"><ArrowLeft size={16} /> All packages</Link>
      <div className="grid lg:grid-cols-12 gap-10 mt-6 items-start">
        <Reveal className="lg:col-span-7">
          <span className="eyebrow">{p.tag}</span>
          <h1 data-testid="package-title" className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mt-3">{p.name} <span className="neon-text">Package</span></h1>
          <p className="mt-4 text-[var(--muted)] max-w-xl">{p.text}</p>
          <ul className="grid sm:grid-cols-2 gap-3 mt-8">
            {p.features.map((f) => <li key={f} className="glass rounded-2xl p-4 flex gap-2 text-sm"><Check size={18} className="text-[var(--pink)] shrink-0" /> {f}</li>)}
          </ul>
        </Reveal>
        <aside className="lg:col-span-5 glass rounded-[2rem] p-8 shadow-[0_0_40px_-12px_var(--glow-pink)]">
          <img data-testid="package-detail-image" src={p.image} alt={`${p.name} bundle`} className="w-full max-w-sm mx-auto aspect-[5/6] object-contain drop-shadow-[0_20px_30px_rgba(0,0,0,0.35)] mb-6" />
          <span className="rounded-full bg-[var(--gold)] text-[#3b0f1e] text-xs font-bold px-3 py-1">Save {save}%</span>
          <p className="mt-4"><span data-testid="package-price" className="text-5xl font-bold neon-text">{inr(p.price)}</span><span className="line-through text-[var(--muted)] ml-3">{inr(p.oldPrice)}</span></p>
          <p className="text-sm text-[var(--muted)] mt-2">{included.length} course{included.length > 1 ? "s" : ""} included</p>
          <button data-testid="package-detail-buy-btn" onClick={() => buy(p)} className="btn-neon w-full justify-center mt-6">Buy Now</button>
        </aside>
      </div>
      <h2 className="font-display text-4xl font-bold mt-20 mb-8">Courses <span className="neon-text">included</span></h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
        {included.map((c, i) => <CourseCard key={c.slug} c={c} i={i} />)}
      </div>
    </div>
  );
}
